import useSplitedTableByColumn from '../../../hooks/useSplitedTableByColumn';
import { Table } from '../../Table';
import { Box } from '@mantine/core';
import { StyledTables } from '../style';
import { TableComponentProps } from '../types';

const _tables = [
  {
    name: 'Estimated % of market value of securities traded',
    key: 'market',
    order: 186,
    columnLables: {
      regulated_market_rate: {
        name: 'On a regulated exchange',
        letter: 'A'
      },
      otc_rate: {
        name: 'OTC',
        letter: 'B'
      }
    }
  },
  {
    name: 'Estimated % of trade volume of derivatives traded',
    key: 'market2',
    order: 187,
    columnLables: {
      regulated_derivative_market_rate: {
        name: 'On a regulated exchange',
        letter: 'A'
      },
      otc_derivative_rate: {
        name: 'OTC',
        letter: 'B'
      }
    }
  }
];

const _tables2 = [
  {
    name: 'Estimated % of Trade volumes of derivative transactions cleared',
    key: 'market',
    order: 188,
    columnLables: {
      ccp_clearing_rate: {
        name: 'by a CCP',
        letter: 'A'
      },
      bilateral_clearing_rate: {
        name: 'Bilaterally',
        letter: 'B'
      }
    }
  },
  {
    name: 'Estimated % of Market value of repo trades cleared',
    key: 'market2',
    order: 189,
    columnLables: {
      ccp_repo_clearing_rate: {
        name: 'by a CCP',
        letter: 'A'
      },
      bilateral_repo_clearing_rate: {
        name: 'Bilaterally',
        letter: 'B'
      },
      tri_party_repo_clearing_rate: {
        name: 'by Tri-party',
        letter: 'C'
      }
    }
  }
];

export function Tranding({
  funds,
  onChangeFund,
  currentDataKey,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const {
    tables,
    columns: columns,
    onChange: onChange
  } = useSplitedTableByColumn({
    data: funds[currentDataKey]?.fund_data?.TRADING_CLEARING_DETAILS,
    onChangeFund,
    schema: schema.TRADING_CLEARING_DETAILS,
    isStaticTemplate,
    requiredFields:
      funds[currentDataKey]?.required_tables?.TRADING_CLEARING_DETAILS?.field_names || [],
    tableName: 'TRADING_CLEARING_DETAILS',
    tables: _tables,
    isMultiFunds,
    funds,
    isSingleData: true
  });

  const {
    tables: tables2,
    columns: columns2,
    onChange: onChange2
  } = useSplitedTableByColumn({
    data: funds[currentDataKey]?.fund_data?.TRADING_CLEARING_DETAILS,
    onChangeFund,
    schema: schema.TRADING_CLEARING_DETAILS,
    isStaticTemplate,
    requiredFields:
      funds[currentDataKey]?.required_tables?.TRADING_CLEARING_DETAILS?.field_names || [],
    tableName: 'TRADING_CLEARING_DETAILS',
    tables: _tables2,
    isMultiFunds,
    funds,
    isSingleData: true
  });

  return (
    <Box
      // @ts-ignore
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 10
      }}
    >
      <StyledTables id="fca-reporttables-tranding-group-1">
        {tables.map((rows, index) => (
          <Table
            id={`fca-reporttables-tranding-table-1-${index + 1}`}
            key={index + 'TRADING_CLEARING_DETAILS'}
            handleChanges={onChange}
            columns={columns}
            rows={rows}
            stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 3 : null}
          />
        ))}
      </StyledTables>
      <StyledTables id="fca-reporttables-tranding-group-2">
        {tables2.map((rows, index) => (
          <Table
            id={`fca-reporttables-tranding-table-2-${index + 1}`}
            key={index + 'TRADING_CLEARING_DETAILS-2'}
            handleChanges={onChange}
            columns={columns}
            rows={rows}
            stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 3 : null}
          />
        ))}
      </StyledTables>
    </Box>
  );
}
